// extracted by mini-css-extract-plugin
export default {"Link":"TextButton_Link__hcv61"};